import { useState, useEffect } from "react";
import { VideoBackground } from "@/components/VideoBackground";
import { MinimalisticPlayer } from "@/components/MinimalisticPlayer";
import { FooterLinks } from "@/components/FooterLinks";
import { SEOHead } from "@/components/SEOHead";
import { StructuredData } from "@/components/StructuredData";
import { supabase } from "@/integrations/supabase/client";
import { useIsMobile } from "@/hooks/use-mobile";

const Index = () => {
  const [selectedAirport, setSelectedAirport] = useState<string>("");
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const isMobile = useIsMobile();

  const handleAirportSelect = (airportCode: string) => {
    setSelectedAirport(airportCode);
  };

  // Fetch video URL for mobile player
  useEffect(() => {
    const fetchVideo = async () => {
      const { data } = supabase.storage.from('videos').getPublicUrl('background-video.mp4');
      if (data?.publicUrl) {
        setVideoUrl(data.publicUrl);
      }
    };
    fetchVideo();
  }, []);

  return (
    <>
      <SEOHead />
      <StructuredData />
      
      {/* Only show VideoBackground on desktop - mobile has it integrated in player */}
      {!isMobile && (
        <VideoBackground
          storageKey="background-video.mp4"
          title="Ambient airplane flying above clouds - Sky Lofi ATC background video"
        />
      )}
      
      {/* Desktop-only SEO footer text — hidden on mobile (shown inside player instead) */}
      {!isMobile && (
        <footer className="fixed bottom-2 left-0 right-0 z-10 flex flex-col items-center opacity-40 hover:opacity-70 smooth-transition pointer-events-none">
          <h1 className="text-[10px] md:text-xs font-medium text-foreground/70 leading-tight text-center">
            Sky Lofi ATC – Lofi Beats with Live Air Traffic Control
          </h1>
          <h2 className="text-[8px] md:text-[10px] text-foreground/50 leading-tight text-center">
            Free 24/7 study music for coding, work &amp; relaxation
          </h2>
        </footer>
      )}

      <main role="main">
        <MinimalisticPlayer 
          selectedAirport={selectedAirport}
          onAirportSelect={handleAirportSelect}
          videoUrl={videoUrl}
        />
      </main>

      <FooterLinks />
    </>
  );
};

export default Index;
